module.exports = __webpack_public_path__ + "img/icon-yanfei.c456444d.webp";